import { Skeleton, Modal } from "antd";
import { useGetSectors } from "features/jobs/hooks/useGetSectors";
import { IProject, IWorkHistory } from "features/settings/types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FileViewerModal } from "./FileViewerModal";

export const Projects: React.FC<{
  data: IProject[];
  isLoading?: boolean;
}> = ({ data, isLoading }) => {
  const { data: sectorData } = useGetSectors();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  // 👇 new state for the file viewer modal
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeFile, setActiveFile] = useState<string | null>(null);

  const handleEyeIconClick = (item: IWorkHistory) => {
    const sector = sectorData?.find((sec) => sec.id === item.sector_id);
    setModalContent(
      <div>
        <h1>
          <span className="font-medium pr-2">Sector:</span>
          <span> {sector?.name} </span>
        </h1>
        <p className="pt-1 text-justify">
          <span className="font-medium">Description:</span>
          <span className="text-sm pl-2">{item.description}</span>
        </p>
      </div>,
    );
    setIsModalVisible(true);
  };

  return (
    <>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-8 gap-x-4 gap-y-3">
        <div className="md:col-span-2 lg:col-span-4">
          <Skeleton active loading={isLoading}>
            {data.map((item) => (
              <div
                key={item.id}
                className="border bg-white rounded-md px-4 py-5 mb-4 hover:border-secondary"
              >
                <div className="flex justify-between items-start">
                  <div className="w-full space-y-2">
                    {item.title && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Title:
                        </span>{" "}
                        {item.title}
                      </p>
                    )}
                    {item.description && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Description:
                        </span>{" "}
                        {item.description}
                      </p>
                    )}
                    {item.type && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Type:
                        </span>{" "}
                        {item.type}
                      </p>
                    )}
                    {item.role && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Role:
                        </span>{" "}
                        {item.role}
                      </p>
                    )}
                    {item.link && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Link:
                        </span>{" "}
                        <button
                          type="button"
                          onClick={() => {
                            setActiveFile(item.link);
                            setViewerOpen(true);
                          }}
                          className="text-primary hover:underline"
                        >
                          View Project
                        </button>
                      </p>
                    )}
                    {item.date && (
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold text-gray-800">
                          Date:
                        </span>{" "}
                        {item.date}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Skeleton>
        </div>
      </div>

      {/* 👇 Once per component, outside the map */}
      <FileViewerModal
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        fileUrl={activeFile}
        fileType={activeFile?.toLowerCase().endsWith(".pdf") ? "pdf" : "image"}
      />
    </>
  );
};
